export default __webpack_public_path__ + "static/media/mentoria.631f1346.png";